import HorizontalRowsInfo from 'components/Dashboard/cards/common/HorizontalRowsInfo'
import Section from '../Section'

type OpenHeaderProps = {
  title: string
  address: string
  state: string
  phone: string
  gender: string
  dob: string
  height: string
  weight: string
}

const OpenHeader = ({ title, address, state, phone, gender, dob, height, weight }: OpenHeaderProps) => {
  const rows = { gender, dob, height, weight }

  return (
    <div className="w-3/4">
      <Section sectionName={'Patient'} title={title} address={address} state={state} phone={phone} />
      <HorizontalRowsInfo className="gap-5" {...rows} />
    </div>
  )
}

export default OpenHeader
